import React from "react";
import {
  useAssignProjectToPortfolio,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";

import { ProjectPortfolioTag } from "@common/projectPortfolioTag";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolio({ portfolio, addPortfolios }: Props) {
  return (
    <div
      className={styles.projectPortfolio}
      onClick={() => addPortfolios(portfolio)}
    >
      <ProjectPortfolioTag {...portfolio} />
    </div>
  );
}

export { ProjectPortfolio };
